import { APIHandler } from "../base";
import { SourceRequest } from "../../common/interfaces/comps/source-request.interface";

export const getPresignedUrl = (sourceRequest: SourceRequest) =>
    APIHandler.post(`/sources/getPresignedUrl`, sourceRequest);

export const getRRQuote = (rrId: string, range: number) =>
    APIHandler.get(`/sources/${rrId}/range/${range}/quote`);
